import { createFileRoute } from "@tanstack/react-router";
import HowTmsTherapyAffectsTheBrainPage from "@/pages/articles/HowTmsTherapyAffectsTheBrainPage";
export const Route = createFileRoute("/how-tms-therapy-affects-the-brain")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How TMS Affects the Brain | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How does TMS therapy affect the brain? Learn about neural circuits, neuroplasticity, and depression treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "How TMS Affects the Brain | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How does TMS therapy affect the brain? Learn about neural circuits, neuroplasticity, and depression treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/how-tms-therapy-affects-the-brain",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-tms-therapy-affects-the-brain",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowTmsTherapyAffectsTheBrainPage />;
}
